import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initNative } from './capacitor/nativeInit';
import { initOtaUpdater } from './capacitor/otaUpdater';

// Set up native listeners/config (no-op on web).
initNative();
// Attach OTA listeners before Capgo's launch check fires (no-op on web).
initOtaUpdater();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
